import Cookies from "js-cookie";
import DeviceDetector from "device-detector-js";
import { LegalArea } from "@/core/types/types";

declare global {
  interface Window {
    amplitude: {
      getSessionId: () => number;
      getDeviceId: () => string;
      Identify: new () => { set: (key: string, value: any) => void };
      identify: (identify: any) => void;
      setUserId: (userId: string) => void;
    };
  }
}

export const pushCCStartedLynxWebhook = (flightProblem: string | undefined) => {
  const waitForConsentAndPush = () => {
    const legalArea = Cookies.get("legalArea");
    if (
      legalArea === LegalArea.APR &&
      Array.isArray(window.dataLayer) &&
      window.dataLayer.some((item) => item.event === "cookie_consent_update") &&
      window.amplitude &&
      window.amplitude.getSessionId() &&
      window.amplitude.getDeviceId()
    ) {
      const device = new DeviceDetector().parse(navigator.userAgent);
      const deviceCategory = device.device?.type || "unknown";
      const browserCategory = device.client?.name || "unknown";

      fetch(`api/pushCCStartedLynxWebhook`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          flightProblem: flightProblem,
          amplitudeSessionId: window.amplitude?.getSessionId(),
          amplitudeDeviceId: window.amplitude?.getDeviceId(),
          amplitudeDeviceCategory: deviceCategory,
          amplitudeBrowserCategory: browserCategory,
          userAgentOS: device.os?.name,
          userAgentOSVersion: device.os?.version,
          screenResolution: `${window.screen.width}x${window.screen.height}`,
        }),
      });
    } else {
      setTimeout(waitForConsentAndPush, 1000);
    }
  };
  waitForConsentAndPush();
};
